module.exports = __webpack_public_path__ + "static/media/img115.6faf36f6.jpg";